'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import UILink from 'UIComponents/link/UILink';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { OLAF } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import { closeAppFromNative } from '../../utils/native/closeAppFromNative';
import { sendNativeAction } from '../../utils/native/sendNativeAction';
import { isHubspotAndroid, isHubSpotNativeApp } from '../../utils/utils';
const ButtonWrapper = styled(UIFlex).withConfig({
  displayName: "NativeBackButton__ButtonWrapper",
  componentId: "tjrif5-0"
})(["padding:0 ", ";position:sticky;z-index:3;top:0;background:", ";height:54px;"], ({
  isAndroid
}) => isAndroid ? '8px 0 16px' : '16px', OLAF);

const NativeBackButton = () => {
  const {
    pathname,
    state: {
      backLocation
    } = {}
  } = useLocation();
  const {
    replace
  } = useHistory();
  const [backLink, setBackLink] = useState('');
  if (!backLink && backLocation) setBackLink(backLocation);
  const handleClose = useCallback(() => {
    if (/^\/lessons\/[0-9]+/.test(pathname) || /^\/tracks\/[0-9]+/.test(pathname)) {
      replace(backLink || '/');
    } else {
      sendNativeAction(closeAppFromNative());
    }
  }, [pathname, replace, backLink]);
  if (!isHubSpotNativeApp) return null;
  const iconName = isHubspotAndroid ? 'previous' : 'left';
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    align: "center",
    "data-test-id": "mobile-close-button",
    children: isHubspotAndroid ? /*#__PURE__*/_jsx(UIIconButton, {
      onClick: handleClose,
      use: "link",
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: iconName,
        size: "small"
      })
    }) : /*#__PURE__*/_jsx(UIBackButton, {
      onClick: handleClose,
      style: {
        display: 'inline-flex'
      },
      children: /*#__PURE__*/_jsx(UILink, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.closeWebviewButton"
        })
      })
    })
  });
};

export default NativeBackButton;